import { PermissionStatus, PushNotifications, Token } from '@capacitor/push-notifications'
import { PermissionState } from '@/types/Permissions.ts'

export async function initPushNotifications(setMessaging: (token: string | undefined) => void): Promise<void> {
    PushNotifications.checkPermissions().then((result: PermissionStatus): void => {
        setMessaging(undefined)
        if (result.receive === PermissionState.granted) {
            PushNotifications.register()
        } else if (result.receive !== PermissionState.denied) {
            PushNotifications.requestPermissions().then((result: PermissionStatus): void => {
                if (result.receive === PermissionState.granted) {
                    PushNotifications.register()
                }
            })
        }
    })

    PushNotifications.addListener('registration', (token: Token): void => {
        setMessaging(token.value || undefined)
    })

    PushNotifications.addListener('registrationError', (): void => {
        setMessaging(undefined)
    })
}
